export function stickyHeader() {
    const isIE = this.isIE;
    if(isIE) {
        document.body.addEventListener("mousewheel", function () {
            event.preventDefault();
            let wheelDelta = event.wheelDelta;
            let currentOffset = window.pageYOffset;
            window.scrollTo(0, currentOffset - wheelDelta);
        });
    }

    $(window).scroll(function() {
        if ($(this).scrollTop() > 1){
            $('.home-header').addClass("no-transparent");
        }
        else{
            $('.home-header').removeClass("no-transparent");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyHeader.js